/* Moved from sections/hlth-social-proof.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var section = document.querySelector('.hlth-sp-' + SID + '');
        if (!section) return;
        var wrap = section.querySelector('[data-sp-video]');
        if (!wrap) return;
        var video = wrap.querySelector('video');
        if (!video) return;
        var playBtn = wrap.querySelector('[data-sp-play]');
        var muteBtn = wrap.querySelector('[data-sp-mute]');
        var thumb = wrap.querySelector('.hlth-sp-thumb');
        var iconUnmute = muteBtn ? muteBtn.querySelector('[data-icon-unmute]') : null;
        var iconMute = muteBtn ? muteBtn.querySelector('[data-icon-mute]') : null;

        if (playBtn) {
          playBtn.addEventListener('click', function() {
            video.muted = false;
            video.play();
            playBtn.classList.add('is-hidden');
            if (thumb) thumb.classList.add('is-hidden');
            if (muteBtn) muteBtn.classList.add('is-visible');
            if (iconUnmute && iconMute) {
              iconUnmute.style.display = '';
              iconMute.style.display = 'none';
            }
          });
        }

        if (muteBtn) {
          muteBtn.addEventListener('click', function() {
            video.muted = !video.muted;
            if (iconUnmute && iconMute) {
              iconUnmute.style.display = video.muted ? 'none' : '';
              iconMute.style.display = video.muted ? '' : 'none';
            }
          });
        }

        video.addEventListener('ended', function() {
          if (playBtn) playBtn.classList.remove('is-hidden');
          if (thumb) thumb.classList.remove('is-hidden');
        });

        video.addEventListener('click', function() {
          if (!video.paused) video.pause();
          else video.play();
        });
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-social-proof')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-social-proof').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_social_proof) return;
      w.__hlthJs_hlth_social_proof = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
